import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { STORAGE_KEYS } from '../utils/storageKeys';

/**
 * Wraps dashboard routes. Redirects to /login when no JWT is stored.
 */
export default function ProtectedRoute() {
  const location = useLocation();
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN);

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
